// extracted by mini-css-extract-plugin
export default {"singleCard":"zbVQ6x_R","scrollerItem":"F7N5dPv1"};